module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit(_vm.item)
      }
    }
  }, [(_vm.item.correction) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', [_vm._v("Faktura korygująca do faktury " + _vm._s(_vm.item.correctedInvoice.fullNumber))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [_c('h3', [_vm._v("Nabywca")]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.name)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_name"
    }
  }, [_vm._v("Nazwa")]), _vm._v(" "), _c('autocomplete', {
    ref: "name",
    attrs: {
      "id": "_name",
      "classes": {
        wrapper: 'form-wrapper',
        input: 'form-control',
        list: 'data-list',
        item: 'data-list-item'
      },
      "onShouldGetData": _vm.searchDebtorByName,
      "onShouldRenderChild": _vm.renderAutocompleteItem,
      "onSelect": _vm.autocompleteItemSelected,
      "debounce": 500,
      "min": 3,
      "onInput": _vm.setNameValue,
      "url": "test",
      "anchor": "name"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.name) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_name_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.customerData.name))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    class: {
      'form-group col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.nip)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_nip"
    }
  }, [_vm._v("NIP")]), _vm._v(" "), _c('autocomplete', {
    ref: "nip",
    attrs: {
      "id": "_nip",
      "classes": {
        wrapper: 'form-wrapper',
        input: 'form-control',
        list: 'data-list',
        item: 'data-list-item'
      },
      "onShouldGetData": _vm.searchDebtorByNip,
      "onShouldRenderChild": _vm.renderAutocompleteItem,
      "onSelect": _vm.autocompleteItemSelected,
      "debounce": 500,
      "min": 2,
      "onInput": _vm.setNipValue,
      "url": "test",
      "anchor": "nip"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.nip) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_nip_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.customerData.nip))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.regon)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_regon"
    }
  }, [_vm._v("REGON")]), _vm._v(" "), _c('autocomplete', {
    ref: "regon",
    attrs: {
      "id": "_regon",
      "classes": {
        wrapper: 'form-wrapper',
        input: 'form-control',
        list: 'data-list',
        item: 'data-list-item'
      },
      "onShouldGetData": _vm.searchDebtorByRegon,
      "onShouldRenderChild": _vm.renderAutocompleteItem,
      "onSelect": _vm.autocompleteItemSelected,
      "debounce": 500,
      "min": 2,
      "onInput": _vm.setRegonValue,
      "url": "test",
      "anchor": "regon"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.regon) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_regon_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.customerData.regon))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    class: {
      'form-group col-lg-8': true, 'has-error': (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.customerAddress && _vm.errors.customerData.customerAddress.street)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_street"
    }
  }, [_vm._v("Ulica")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.customerData.customerAddress.street),
      expression: "item.customerData.customerAddress.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_street"
    },
    domProps: {
      "value": (_vm.item.customerData.customerAddress.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.customerData.customerAddress, "street", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.customerAddress && _vm.errors.customerData.customerAddress.street) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_street_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.customerData.customerAddress.street))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group col-lg-4': true, 'has-error': (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.customerAddress && _vm.errors.customerData.customerAddress.number)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_number"
    }
  }, [_vm._v("Numer domu")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.customerData.customerAddress.number),
      expression: "item.customerData.customerAddress.number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_number"
    },
    domProps: {
      "value": (_vm.item.customerData.customerAddress.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.customerData.customerAddress, "number", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.customerAddress && _vm.errors.customerData.customerAddress.number) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_number_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.customerData.customerAddress.number))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    class: {
      'form-group col-lg-4': true, 'has-error': (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.customerAddress && _vm.errors.customerData.customerAddress.postalCode)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_postalCode"
    }
  }, [_vm._v("Kod pocztowy")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.customerData.customerAddress.postalCode),
      expression: "item.customerData.customerAddress.postalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_postalCode"
    },
    domProps: {
      "value": (_vm.item.customerData.customerAddress.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.customerData.customerAddress, "postalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.customerAddress && _vm.errors.customerData.customerAddress.postalCode) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_postalCode_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.customerData.customerAddress.postalCode))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group col-lg-8': true, 'has-error': (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.customerAddress && _vm.errors.customerData.customerAddress.city)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_city"
    }
  }, [_vm._v("Miasto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.customerData.customerAddress.city),
      expression: "item.customerData.customerAddress.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_city"
    },
    domProps: {
      "value": (_vm.item.customerData.customerAddress.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.customerData.customerAddress, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.customerAddress && _vm.errors.customerData.customerAddress.city) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_city_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.customerData.customerAddress.city))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.customerAddress && _vm.errors.customerData.customerAddress.country)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_country"
    }
  }, [_vm._v("Państwo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.customerData.customerAddress.country),
      expression: "item.customerData.customerAddress.country"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_country"
    },
    domProps: {
      "value": (_vm.item.customerData.customerAddress.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.customerData.customerAddress, "country", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.customerData && _vm.errors.customerData.customerAddress && _vm.errors.customerData.customerAddress.country) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_city_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.customerData.customerAddress.country))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 offset-lg-1"
  }, [_c('h3', [_vm._v("Dane faktury")]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    class: {
      'form-group col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.createDate)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_data"
    }
  }, [_vm._v("Data wystawienia")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Data"
    },
    model: {
      value: (_vm.item.createDate),
      callback: function($$v) {
        _vm.$set(_vm.item, "createDate", $$v)
      },
      expression: "item.createDate"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.createDate) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_data_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.createDate))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.endDate)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_data"
    }
  }, [_vm._v("Data zakończenia")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Data"
    },
    model: {
      value: (_vm.item.endDate),
      callback: function($$v) {
        _vm.$set(_vm.item, "endDate", $$v)
      },
      expression: "item.endDate"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.endDate) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_data_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.endDate))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    class: {
      'form-group col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.paymentDate)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_data"
    }
  }, [_vm._v("Termin zapłaty")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Data"
    },
    model: {
      value: (_vm.item.paymentDate),
      callback: function($$v) {
        _vm.$set(_vm.item, "paymentDate", $$v)
      },
      expression: "item.paymentDate"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.paymentDate) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_data_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.paymentDate))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group col col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.paid)
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "checkbox1"
    },
    model: {
      value: (_vm.item.paid),
      callback: function($$v) {
        _vm.$set(_vm.item, "paid", $$v)
      },
      expression: "item.paid"
    }
  }, [_vm._v("\n                        Opłacona\n                    ")]), _vm._v(" "), (_vm.errors && _vm.errors.paid) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_currency_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.paid))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    class: {
      'form-group col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.currency)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_currency"
    }
  }, [_vm._v("Waluta")]), _vm._v(" "), _c('dropdown-search', {
    attrs: {
      "x": "",
      "elements": _vm.currencyTypes,
      "emptyValue": "Wybierz",
      "valueField": "@id",
      "nameField": "name"
    },
    on: {
      "input": _vm.setCommentIfForeign
    },
    model: {
      value: (_vm.item.currency),
      callback: function($$v) {
        _vm.$set(_vm.item, "currency", $$v)
      },
      expression: "item.currency"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.currency) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_currency_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.currency))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.paymentType)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_currency"
    }
  }, [_vm._v("Sposób zapłaty")]), _vm._v(" "), _c('dropdown-search', {
    attrs: {
      "x": "",
      "elements": _vm.invoicePaymentType,
      "emptyValue": "Wybierz",
      "valueField": "@id",
      "nameField": "name"
    },
    model: {
      value: (_vm.item.paymentType),
      callback: function($$v) {
        _vm.$set(_vm.item, "paymentType", $$v)
      },
      expression: "item.paymentType"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.paymentType) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_currency_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.paymentType))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.comments)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_comments"
    }
  }, [_vm._v("Uwagi")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.comments),
      expression: "item.comments"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_comments"
    },
    domProps: {
      "value": (_vm.item.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "comments", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.comments) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_comments_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.comments))]) : _vm._e()])])]), _vm._v(" "), (_vm.item.correction) ? _c('h3', [_vm._v("Towary/usługi - było")]) : _vm._e(), _vm._v(" "), (_vm.item.correction) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.item.correctedInvoiceItems), function(item, index) {
    return _c('InvoiceItem', {
      attrs: {
        "values": item,
        "index": index
      }
    })
  }), 1)])]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Towary/usługi"), (_vm.item.correction) ? _c('span', [_vm._v(" - powinno być")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "table-invoices"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-clickable"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.item.items), function(invoiceItem, index) {
    return _c('InvoiceItemForm', {
      attrs: {
        "values": _vm.item.items,
        "index": index,
        "errors": _vm.getViolationsForInvoiceItem(index),
        "removeItem": _vm.removeItemRow
      }
    })
  }), 1), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "text-right td-no_link",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Suma:")]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_vm._v(_vm._s(_vm.netPrice))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_vm._v(_vm._s(_vm.tax))]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_vm._v(_vm._s(_vm.grossPrice))]), _vm._v(" "), _c('td')])])])]), _vm._v(" "), _c('my-button', {
    attrs: {
      "text": "Dodaj pozycję",
      "icon": "plus",
      "type": "button",
      "variant": "info",
      "action": _vm.addItemRow
    }
  })], 1), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'InvoiceList'
      }
    }
  }, [_c('span', [_vm._v("Powrót")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1), _vm._v(" "), _c('my-button', {
    attrs: {
      "text": "Zapisz",
      "icon": "tick",
      "type": "submit"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("L.p.")]), _vm._v(" "), _c('th', [_vm._v("Nazwa towaru/usługi")]), _vm._v(" "), _c('th', {
    staticClass: "th-narrow"
  }, [_vm._v("Jm")]), _vm._v(" "), _c('th', {
    staticClass: "th-narrow"
  }, [_vm._v("Ilość")]), _vm._v(" "), _c('th', [_vm._v("Cena netto")]), _vm._v(" "), _c('th', [_vm._v("Wartość netto")]), _vm._v(" "), _c('th', [_vm._v("Stawka VAT")]), _vm._v(" "), _c('th', [_vm._v("VAT")]), _vm._v(" "), _c('th', [_vm._v("Wartość brutto")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("L.p.")]), _vm._v(" "), _c('th', [_vm._v("Nazwa towaru/usługi")]), _vm._v(" "), _c('th', {
    staticClass: "th-narrow"
  }, [_vm._v("Jm")]), _vm._v(" "), _c('th', {
    staticClass: "th-narrow"
  }, [_vm._v("Ilość")]), _vm._v(" "), _c('th', [_vm._v("Cena netto")]), _vm._v(" "), _c('th', [_vm._v("Wartość netto")]), _vm._v(" "), _c('th', [_vm._v("Stawka VAT")]), _vm._v(" "), _c('th', [_vm._v("VAT")]), _vm._v(" "), _c('th', [_vm._v("Wartość brutto")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0794daa8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/Form.vue
// module id = 776
// module chunks = 0